import Swal from 'sweetalert2'
class Loader {
  static show(config) {
    const title = config?.title ?? 'Please wait'
    const text = config?.text ?? null
    const actionsClass = title || text ? '' : 'microba-loader-no-text'

    const defaultConfig = {
      title,
      html: text,
      customClass: {
        actions: actionsClass
      }
    }
    Swal.fire(defaultConfig)
    return Swal.showLoading()
  }

  static hide() {
    return Swal.close()
  }
}

export { Loader }
